var map = {
	"./growing-icon.svg": "221c",
	"./international-market-icon.svg": "a7ae",
	"./local-market-icon.svg": "53f0",
	"./national-market-icon.svg": "5bba",
	"./new-icon.svg": "aba3",
	"./regional-market-icon.svg": "be80",
	"./shrinking-icon.svg": "f1ac",
	"./stagnation-icon.svg": "1b92"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "96f5";